import React from 'react';
import { Link } from 'react-router-dom';
import { Package, Mail, Phone, MapPin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                <Package className="w-6 h-6 text-white" />
              </div>
              <span className="font-heading font-bold text-xl">ISMParcel</span>
            </div>
            <p className="text-slate-400 max-w-md">
              Votre partenaire de confiance pour l'expédition et la réexpédition de colis 
              vers le monde entier. Livraison rapide et sécurisée depuis Béziers.
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="font-heading font-bold mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/tracking" className="text-slate-400 hover:text-white transition-colors">
                  Suivre un colis
                </Link>
              </li>
              <li>
                <Link to="/rates" className="text-slate-400 hover:text-white transition-colors">
                  Nos tarifs
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-slate-400 hover:text-white transition-colors">
                  Créer un compte
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-heading font-bold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-slate-400">
                <Mail className="w-4 h-4" />
                contact@ismparcel.fr
              </li>
              <li className="flex items-center gap-2 text-slate-400">
                <Phone className="w-4 h-4" />
                06 95 14 86 86
              </li>
              <li className="flex items-start gap-2 text-slate-400">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                <span>105 Rue Joseph Marie Jacquard<br />34500 Béziers, France</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8 text-center text-slate-500 text-sm">
          <p>&copy; {new Date().getFullYear()} ISMParcel. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
}
